import { Action } from '@ngrx/store';
import {
    CubeEntry,
    CubeFilterInput
} from 'app/api/cube.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';

export interface CubeQuery {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: CubeFilterInput;
}

export enum CubeActionTypes {
    CubeRemoveAll = '[Cube View] Cube remove all',
    CubeRequested = '[Cube View] Cube requested',
    CubeReloadRequested = '[Cube API] Cube reload requested',
    CubeLoaded = '[Cube API] Cube loaded',
    CubeCancelled = '[Cube API] Cube cancelled',
    CubeSetTimelineScale = '[Cube View] Set Timeline Scale',
}

export class CubeRemoveAll implements Action {
    readonly type = CubeActionTypes.CubeRemoveAll;
}
export class CubeRequested implements Action {
    readonly type = CubeActionTypes.CubeRequested;
    constructor(public payload: CubeQuery) {}
}
export class CubeReloadRequested implements Action {
    readonly type = CubeActionTypes.CubeReloadRequested;
    constructor() {}
}
export class CubeLoaded implements Action {
    readonly type = CubeActionTypes.CubeLoaded;
    constructor(public payload: { cube: CubeEntry[] }) {}
}
export class CubeCancelled implements Action {
    readonly type = CubeActionTypes.CubeCancelled;
    constructor(public payload: { errorMessage: string }) {}
}
export class CubeSetTimelineScale implements Action {
    readonly type = CubeActionTypes.CubeSetTimelineScale;
    constructor(public payload: { timelineScale: string }) {}
}

export type CubeActions =
  CubeRemoveAll
    | CubeRequested
    | CubeReloadRequested
    | CubeLoaded
    | CubeCancelled
    | CubeSetTimelineScale;
